import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/chevron-right-doodle.svg';

var GlobalTitle = function GlobalTitle() {
  return import(
  /* webpackChunkName:"global-editorial" */
  '~/components/atoms/Editorial/Global/GlobalTitle.vue');
};

export default {
  name: 'ChristmasSelection',
  components: {
    GlobalTitle: GlobalTitle
  },
  props: {
    url: {
      type: String,
      required: true
    },
    backgroundColor: {
      type: String,
      default: ''
    },
    src: {
      type: String,
      default: ''
    },
    textColor: {
      type: String,
      required: true
    },
    title: {
      type: Object,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  }
};